<div class="ag-cell-label-container" role="presentation">
  <div class="ag-header-cell-label" role="presentation">
    <span class="ag-header-cell-text">{{ params.displayName }}</span>
    <button
      type="button"
      class="fa-light fa-info-circle ms-2 info-btn"
      [ngbTooltip]="params.tooltipText"
      container="body"
      placement="top"
      [attr.aria-label]="'More info about ' + params.displayName"
    ></button>
    @if (params.enableSorting) {
      <button
        type="button"
        class="ag-header-cell-sort sort-btn"
        (click)="onSortRequested($event)"
        [attr.aria-label]="'Sort by ' + params.displayName"
      >
        @if (sortState === 'asc') {
          <span class="ag-sort-ascending-icon ag-header-icon"><span class="ag-icon ag-icon-asc"></span></span>
        } @else if (sortState === 'desc') {
          <span class="ag-sort-descending-icon ag-header-icon"><span class="ag-icon ag-icon-desc"></span></span>
        } @else {
          <span class="ag-sort-none-icon ag-header-icon"><span class="ag-icon ag-icon-none"></span></span>
        }
      </button>
    }
  </div>
</div>
